var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32231 1.7794C3.09611 2.05079 2.98172 2.39812 3.00238 2.75081V18.0722C2.98289 18.4248 3.09714 18.7717 3.32231 19.0436L3.37466 19.096L11.9544 10.5104V10.3068L3.37466 1.72705L3.32231 1.7794Z",
    fill: "url(#paint0_linear_358_28886)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.815 13.3722L11.9531 10.5103V10.3067L14.815 7.45068L14.879 7.48558L18.2702 9.41094C19.2416 9.95772 19.2416 10.8593 18.2702 11.4119L14.879 13.3373L14.815 13.3722Z",
    fill: "url(#paint1_linear_358_28886)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8822 13.3371L11.9738 10.4287L3.32422 19.0434C3.52359 19.2073 3.77181 19.3002 4.02981 19.3076C4.2878 19.315 4.54093 19.2364 4.74933 19.0841L14.8647 13.3371",
    fill: "url(#paint2_linear_358_28886)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8822 7.48543L4.74933 1.73263C4.54316 1.57412 4.28836 1.49211 4.02844 1.5006C3.76852 1.50909 3.51961 1.60755 3.32422 1.77917L11.9563 10.4113L14.8822 7.48543Z",
    fill: "url(#paint3_linear_358_28886)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.8161 13.2729L4.74725 18.985C4.5464 19.1347 4.30262 19.2155 4.05214 19.2155C3.80167 19.2155 3.55789 19.1347 3.35704 18.985L3.30469 19.0374L3.35704 19.0897C3.55789 19.2394 3.80167 19.3202 4.05214 19.3202C4.30262 19.3202 4.5464 19.2394 4.74725 19.0897L14.8626 13.3428L14.8161 13.2729Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M3.32213 18.9504C3.09659 18.6763 2.98238 18.3275 3.00221 17.9731V18.072C2.98271 18.4246 3.09697 18.7715 3.32213 19.0434L3.37448 18.9911L3.32213 18.9504Z",
    fill: "#1A181E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M18.2716 11.3072L14.8164 13.2733L14.8804 13.3373L18.2716 11.3887C18.4705 11.3012 18.6426 11.1625 18.7704 10.9867C18.8981 10.8109 18.9769 10.6044 18.9987 10.3882C18.959 10.588 18.8724 10.7756 18.7459 10.9354C18.6195 11.0952 18.4569 11.2226 18.2716 11.3072Z",
    fill: "#1A181E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.74504 1.83636L18.2691 9.50871C18.4526 9.59123 18.6141 9.71588 18.7405 9.87254C18.8668 10.0292 18.9544 10.2134 18.9962 10.4103C18.9756 10.1937 18.8972 9.98667 18.7694 9.81069C18.6415 9.63472 18.4687 9.49628 18.2691 9.40982L4.74504 1.73166C3.79108 1.18488 3 1.63859 3 2.7496V2.84848C3 1.7433 3.79108 1.28377 4.74504 1.83636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_358_28886",
    x1: 11.1982,
    y1: 2.58794,
    x2: -0.429522,
    y2: 14.2157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_358_28886",
    x1: 18.3865,
    y1: 10.4114,
    x2: 1.62251,
    y2: 10.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_358_28886",
    x1: 13.2942,
    y1: 11.9992,
    x2: -2.4693,
    y2: 27.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_358_28886",
    x1: 1.14874,
    y1: -3.32216,
    x2: 8.19287,
    y2: 3.71616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.6453ea1a290ddc05e3cd594dfbd9ac9d.svg";
export { ForwardRef as ReactComponent };